export default {
  title: {
    id: 'product_page_obsolete_title',
    defaultMessage: 'Ready to use',
  },
  subtitle: {
    id: 'product_page_obsolete_subtitle',
    defaultMessage: 'Chrome OS Flex pre‑installed • 100% functional',
  },
}
